// This `enum` should map to `FloorGameActivity`:
// Negative = FloorGameActivity.LowDemand
// Neutral = FloorGameActivity.Quiet
// Positive = FloorGameActivity.HighDemand || FloorGameActivity.OnFire
export enum TickStatus {
    Negative = 'negative',
    Neutral = 'neutral',
    Positive = 'positive',
}
